import { t } from "@lingui/macro";

// Epochs

const EPOCHS = [
  ["year", 31536000],
  ["month", 2592000],
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60]
];

const getDuration = (timeAgoInSeconds) => {
  for (let [name, seconds] of EPOCHS) {
    const interval = Math.floor(timeAgoInSeconds / seconds);

    if (interval >= 1) {
      return {
        interval: interval,
        epoch: name
      };
    }
  }
};

export function getDateFormatString(dateTimeValue, short) {
  const SINGULAR_EPOCHS = {
    year: t`year`,
    month: t`month`,
    day: t`day`,
    hour: t`hour`,
    minute: t`minute`,
    y: t`y`,
    mo: t`mo`,
    d: t`d`,
    h: t`h`,
    min: t`min`
  };

  const PLURAL_EPOCHS = {
    year: t`years`,
    month: t`months`,
    day: t`days`,
    hour: t`hours`,
    minute: t`minutes`,
    y: t`y`,
    mo: t`mo`,
    d: t`d`,
    h: t`h`,
    min: t`min`
  };

  function getInterval(timeAgoInSeconds) {
    const epochDetail = getDuration(timeAgoInSeconds);
    if (!epochDetail) {
      return t`1 minute`;
    }
    let { interval, epoch } = epochDetail;
    epoch = interval === 1 ? SINGULAR_EPOCHS[epoch] : PLURAL_EPOCHS[epoch];
    return `${interval} ${epoch}`;
  }

  const dateTimeObj = new Date(dateTimeValue);
  const timeAgoInSeconds = Math.floor((dateTimeObj - new Date()) / 1000);
  if (timeAgoInSeconds < 1) {
    let intervalText = getInterval(Math.abs(timeAgoInSeconds));
    return {
      isOverdue: true,
      label: short ? t`${intervalText} ago` : t`Overdue by ${intervalText}`,
      color: "Red"
    };
  } else {
    let { interval, epoch } = getDuration(Math.abs(timeAgoInSeconds)) || {};
    const dateTimeParts = dateTimeObj.toString().split(" ");
    const intervalText = `${dateTimeParts[2]} ${dateTimeParts[1]}`;
    if (!interval) {
      return {
        isOverdue: false,
        color: "Orange",
        label: short ? intervalText : t`Due date on ${intervalText} `
      };
    }
    epoch = SINGULAR_EPOCHS[epoch];
    return {
      isOverdue: false,
      color:
        (epoch === "day" && interval <= 3) || epoch !== "day" ? "Orange" : "",
      label: short ? intervalText : t`Due date on ${intervalText}`
    };
  }
}
